import { ApiError, isPermissionRefused } from '@citibox-panel/api-client';

export type SaveFailure =
  | { kind: 'denied' }
  | { kind: 'conflict' }
  | { kind: 'message'; text: string };

// TODO: i18n
const GENERIC = 'No se han podido guardar los cambios. Vuelve a intentarlo.';
// A Map, not an object literal: a code such as «constructor» must miss, never resolve to a
// built-in of Object.prototype.
const COPY: ReadonlyMap<string, string> = new Map([
  ['assignment_self_edit', 'No puedes modificar tu propia asignación.'],
  ['assignment_systems_protected', 'Las personas de Sistemas se gestionan desde backend.'],
  ['assignment_permission_not_assignable', 'Ese permiso no se puede asignar desde aquí.'],
  ['assignment_email_invalid', 'Escribe un email @citibox.com.'],
]);

// Only the code decides the text. The server's message and detail are never read, so they cannot
// end up rendered. Any recognised permission refusal is a denial, whichever code the server used.
export function classifySaveError(error: unknown): SaveFailure {
  if (isPermissionRefused(error)) return { kind: 'denied' };
  if (!(error instanceof ApiError)) return { kind: 'message', text: GENERIC };
  if (error.status === 409) return { kind: 'conflict' };
  return { kind: 'message', text: COPY.get(error.code) ?? GENERIC };
}
